module.exports = Promise.resolve({
  get: () => Promise.resolve(() => {
    const NullComponent = () => null;
    return { __esModule: true, default: NullComponent };
  }),
  init: () => Promise.resolve()
});